import { useAuth } from '../contexts/AuthContext';

// Define which navigation items are accessible to each role
const roleAccess = {
  admin: 'all', // Admin has access to everything
  author: [
    'Dashboard',
    'My Profile', 
    'Blogs',
    'Courses',
    'Tags',
    'Classrooms',
    'Categories',
    'Enrolled Students'
  ]
};

// Filter navigation groups based on user role
export const filterNavigationByRole = (navigationGroups, userRole) => {
  if (!userRole || userRole === 'admin') {
    return navigationGroups; // Admin sees everything
  }

  const allowedItems = roleAccess[userRole] || [];
  
  return navigationGroups.map(group => ({
    ...group,
    items: group.items.filter(item => {
      // Always allow Dashboard and Profile for authenticated users
      if (item.name === 'Dashboard' || item.name === 'My Profile') {
        return true;
      }
      
      // Check if item is admin-only
      if (item.adminOnly && userRole !== 'admin') {
        return false;
      }
      
      // Check if item is in the allowed list for the role
      return allowedItems.includes(item.name);
    })
  })).filter(group => group.items.length > 0); // Remove empty groups
};

// Hook to get filtered navigation
export const useFilteredNavigation = (navigationGroups) => {
  const { userRole } = useAuth();
  return filterNavigationByRole(navigationGroups, userRole);
};
